import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { MatTableDataSource } from '@angular/material/table';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { Router } from '@angular/router';
import moment from 'moment';
import { Observable, of as observableOf, Subject } from 'rxjs';
import { ReferentielType, Result } from 'src/app/fragments/modal/recherche-referentiel/recherche-referentiel.component';
import { ModalService } from 'src/app/services/modal/modal.service';
import { HeaderCommunicationService } from 'src/app/services/node/header-communication.service';
import { CabinetService } from 'src/app/services/office/cabinet.service';
import { RechercheMultiService, numberType, stringType } from 'src/app/services/recherche/recherche-multi.service';
import { RechercheReferentielsService } from 'src/app/services/rechercheReferentiels/recherche-referentiels.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { ReferentielEnum } from 'src/app/utils/enums/referentiel-enum';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Header } from 'src/app/utils/interfaces/new/header.interface';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { CritereFlatNode, CritereNode, CritereRecherche, LabelValue, RechercheMultiCriteres } from 'src/app/utils/interfaces/new/recherche';
import { ResultatPatient } from 'src/app/utils/interfaces/new/resultat-patient.interface';
import { CardIcon } from 'src/app/utils/interfaces/old/card-icon-interface';

@Component({
  selector: 'app-recherche-multi',
  templateUrl: './recherche-multi.component.html',
  styleUrls: ['./recherche-multi.component.scss']
})
export class RechercheMultiComponent implements OnInit {

  public emptyIconEdit: CardIcon = {
    src: 'assets/icons/download.svg',
    color: 'var(--grey3)',
    fill: 'var(--grey3)',
    title: 'Export CSV'
  };

  // Icone pour ouvrir la modale de chargement
  public fullIconAdd: CardIcon = {
    src: 'assets/icons-white/search.svg',
    color: 'var(--primary)',
    title: 'Charger une recherche sauvegardée'
  };

  // Type de condition pour le critère sélectionné
  public typesOfConditions: LabelValue[] = [];

  // Critère sélectionné par l'utlisateur
  public activeNode: CritereFlatNode;

  // Si le critère sélectionné est une liste de valeur (sinon saisie libre)
  public isValueList: boolean = false;

  // Si le critère sélectionné est une sous liste de valeur
  public isValueSubList: boolean = false;

  // Liste de valeur pour le critère sélectionné
  public valueList: LabelValue[] = [];
  public valueListFiltered: LabelValue[] = [];

  // Controleur de l'arbre de critères
  treeControl: FlatTreeControl<CritereFlatNode>;

  // Transformateur de données pour l'arbre de critères
  treeFlattener: MatTreeFlattener<CritereNode, CritereFlatNode>;

  // Source de données pour l'arbre de critères
  dataSource: MatTreeFlatDataSource<CritereNode, CritereFlatNode>;

  // Référence vers la liste déroulante valeurs
  @ViewChild("values") values: MatSelectionList;

  // Référence vers la liste déroulante conditions
  @ViewChild("conditions") conditions: MatSelectionList;

  // Valeur saisie par l'utilisateur
  public typedValue: string;

  // Valeur saisie par l'utilisateur
  public subTypedValue: string;

  public referentielType = ReferentielType;

  public cim10Result: Result | null = null;

  get isCim10Critere(): boolean {
    return this.activeNode?.name === 'ATCD perso code CIM 10' || 
           this.activeNode?.name === 'ATCD fam code CIM 10';
  }

  // Valeur sélectionnée par l'utilisateur
  public selectedValue: LabelValue;

  // Selection choisir par l'utilisateur
  public selectedCondition: LabelValue;

  // Liste des patients qui répondent aux critères de recherche
  public patientList: Paginated<any>;

  // Stream avec les modales pour raffraichir les critères
  public refreshStream: Subject<any>;

  // Indique si la recherche est en cours
  public isTableLoading: boolean = false;
  public isSearching: boolean = false;

  // Filtres du tableau de patient (recherche)
  public filtre: Filtres = {
    perpage: 50,
    currentPage: 1
  };

  // Liste des critères de recherche
  listeCriteresRecherche: CritereRecherche[] = [];
  listeCriteresRechercheDatasource = new MatTableDataSource<CritereRecherche>();

  // Critère de recherche issu de la base
  rechercheSauvegardee: RechercheMultiCriteres;

  constructor(
    private _router: Router, 
    private modalService: ModalService, 
    private _viewRef: ViewContainerRef, 
    private rechercheSvc: RechercheMultiService, 
    private _send: HeaderCommunicationService,
    private _ref: ReferentielService,
    private _cabinet: CabinetService,
    private _strUtilsSrv: StringUtilsService,
    private _rechercheRefSrv: RechercheReferentielsService
  ) {
    const head: Header = {
      backPage: 'utilitaires',
      isBack: true,
      title: 'Recherche',
    };
    this._send.announceHeader(head);

    // Initialisation de l'arbre des critères
    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel, this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<CritereFlatNode>(this._getLevel, this._isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.dataSource.data = rechercheSvc.getCriteres();
  }

  // Initialisation de la page
  ngOnInit(): void {
    // Abonnement aux modales
    this.refreshStream = new Subject();
    this.refreshStream.subscribe(async (event) => {
      if (event && event.domain && event.domain === "recherche") {
        if (event.operation === "delete") {
        } else if (event.operation === "load") {
          // Dans le cas où l'utilisateur souhaite charger une recherche préenregistrée
          this.rechercheSauvegardee = event.object;
          this.listeCriteresRecherche = this.rechercheSauvegardee.criteres;
          this.refreshCritere();
        } else if (event.operation === "enable") {
          if (event.object) {
            await this.rechercheSvc.enableRecherche(event.object.id, event.object.enable);
          }
        }
      }
    })
    this.loadSearchSession();
  }

  // Liste des colonnes affichées dans le tableau des critères de recherche
  public displayedColumns: string[] = ['operator', 'critereName', 'conditionName', 'value', 'action'];

  // Liste des colonnes affichées dans le tableau de résultat
  public patientColumnTable = [
    { title: '', data: 'tag', isCellColor: true },
    { title: 'Patient', data: 'nomPrenom' },
    { title: 'Nom de naissance', data: 'nomNaissance' },
    { title: 'Nom d\'usage', data: 'nomUsage' },
    { title: 'Date de naissance', data: 'birthday' },
  ];

  // Méthode utilitaire pour transformer des listes hierarchiques en liste plates (nécessaire pour le MatTree)
  private transformer = (node: CritereNode, level: number) => {
    let flatNode = new CritereFlatNode();
    flatNode.name = node.name;
    flatNode.type = node.type;
    flatNode.level = level;
    flatNode.expandable = !!node.children;
    return flatNode;
  }

  // Méthode utilitaire pour retourner le niveau de la liste (nécessaire pour le MatTree)
  private _getLevel = (node: CritereFlatNode) => { return node.level; };

  // Méthode utilitaire pour savoir si le noeud peut être étendu ou non (nécessaire pour le MatTree)
  private _isExpandable = (node: CritereFlatNode) => { return node.expandable; };

  // Méthode utilitaire pour récupérer la liste des enfants d'un noeud (nécessaire pour le MatTree)
  private _getChildren = (node: CritereNode): Observable<CritereNode[]> => {
    return observableOf(node.children);
  }

  // Méthode utilitaire pour savoir si le noeud à des enfants ou non (nécessaire pour le MatTree)
  hasChild = (_: number, _nodeData: CritereFlatNode) => { return _nodeData.expandable; };

  // Comportement lorsqu'une feuille de l'arbre est sélectionnée
  async selectNode(node: CritereFlatNode, forceType?: LabelValue[]) {
    this.activeNode = node;
    let oldTypeOfConnditions = this.typesOfConditions;
    if (forceType) {
      this.typesOfConditions = forceType;
    } else {
      this.typesOfConditions = this.rechercheSvc.getConditionsByTypeCritere(node.type);
    }
    // Si le nouveau type de condition est différent, alors on reset la saisie utilisateur (il est possible que les entréees ne soient pas comatibles)
    if (oldTypeOfConnditions !== this.typesOfConditions) {
      this.selectedCondition = undefined;
    }
    this.isValueList = this.rechercheSvc.isTypeCritereIsList(node.type);
    this.isValueSubList = this.rechercheSvc.isTypeCritereIsSubList(node.type);
    if (this.isValueList) {
      // On reset la saisie libre comme une liste déroulante est affichée
      this.typedValue = undefined;
      this.valueList = await this.rechercheSvc.getValueListByTypeCritere(node.type);
      this.valueListFiltered = JSON.parse(JSON.stringify(this.valueList));
    } else {
      // On reset la saisie liste comme aucune liste n'est affichée
      this.selectedValue = undefined;
    }
  }


  // Ajout d'un critère à la recherche
  addCritere() {
    let value = "";
    let valueLabel = "";
    let subValue: string;
    
    // Si c'est un critère CIM-10, utiliser le résultat de la recherche
    if (this.isCim10Critere && this.cim10Result) {
      value = this.cim10Result.id.split('++')[0]; 
      valueLabel = this.cim10Result.libelle;    
    } else if (this.selectedValue) {
      if (moment(this.selectedValue.value, 'YYYY-MM-DD', true).isValid()) {
        value = this.selectedValue.value;
        valueLabel = moment(this.selectedValue.value, 'YYYY-MM-DD').format('DD-MM-YYYY');
      } else {
        // Pour les types de documents, nettoyer la valeur (enlever l'OID après '++')
        if (this.activeNode.type === 'type-document' && this.selectedValue.value.includes('++')) {
          value = this.selectedValue.value.split('++')[0];
        } else {
          value = this.selectedValue.value;
        }
        valueLabel = this.selectedValue.label;
        if (this.typedValue === "duree") {
          subValue = this.subTypedValue;
        }
      }
    } else {
      if (moment(this.typedValue, 'YYYY-MM-DD', true).isValid()) {
        value = this.typedValue;
        valueLabel = moment(this.typedValue, 'YYYY-MM-DD').format('DD-MM-YYYY');
      } else {
        value = this.typedValue;
        valueLabel = this.typedValue;
      }
    }
    this.listeCriteresRecherche.push({ conditionName: this.selectedCondition.label, conditionValue: this.selectedCondition.value, critereName: this.activeNode.name, critereType: this.activeNode.type, operator: "AND", value: value.toString(), valueLabel: valueLabel.toString(), subValue: this.isValueSubList ? this.subTypedValue : (subValue ?? '') });
    this.subTypedValue = '';
    this.typedValue = '';
    this.cim10Result = null; // Réinitialiser le résultat CIM-10
    this.refreshCritere();
  }

  // Suppression d'un critère de recherche
  deleteCritere(critere: CritereRecherche) {
    let index = -1;
    for (let i = 0; i < this.listeCriteresRecherche.length; i++) {
      let c = this.listeCriteresRecherche[i];
      if (c.conditionName === critere.conditionName && c.conditionValue === critere.conditionValue && c.critereName === critere.critereName && c.critereType === critere.critereType && c.operator === critere.operator && c.value === critere.value) {
        index = i;
        break;
      }
    }
    if (index !== -1) {
      this.listeCriteresRecherche.splice(index, 1);
      this.refreshCritere();
    }
  }

  // Raffraichissement du tableau des critères (technique)
  refreshCritere() {
    this.listeCriteresRechercheDatasource.data = this.listeCriteresRecherche;
  }

  // Comportement lors de la sélection d'une valeur
  async onSelectedValueChange() {
    if (this.values?.selectedOptions?.selected[0]?.value !== undefined) {
      this.selectedValue = this.values.selectedOptions.selected[0]?.value;
      if (this.isValueSubList && this.selectedValue) {
        // Dans le cas des critères/liste de critères, le choix de l'utilisateur pour influencer le type de conditions
        if (await this.rechercheSvc.isCritereNumeric(this.activeNode.type, this.selectedValue.value)) {
          this.selectNode(this.activeNode, numberType);
        } else {
          this.selectNode(this.activeNode, stringType);
        }
      }
    }
  }

  onNumberValueChange(event: any, type: string) {
    this.typedValue = type;
    this.subTypedValue = event + '';
  }

  async openCim10Search() {
    const result = await this._rechercheRefSrv.initRecherche(
      this._viewRef, 
      [ReferentielType['cim-10']]
    );
    
    if (result && typeof result === 'object') {
      this.cim10Result = result;
    }
  }

  onUniteDureeValueChange(event: any) {
    this.selectedValue = event;
  }


  // Comportement lors de la sélection d'une condition
  onConditionChange() {
    if (this.conditions?.selectedOptions?.selected[0]?.value !== undefined) {
      this.selectedCondition = this.conditions.selectedOptions.selected[0]?.value;
    }
  }

  // Lancement de la recherche
  async lancerRecherche() {
    this.isSearching = true;
    this.isTableLoading = true;
    this.storeSearchSession();
    const patientList = await this.rechercheSvc.rechercher(this.listeCriteresRecherche, this.filtre);
    const patientsTmp: Array<ResultatPatient & { birthday: string }> = [];
    for (const p of patientList.objects) {
      const pp: any = p;
      pp.birthday = p.dateNaissance;
      patientsTmp.push(pp);
    }
    patientList.objects = patientsTmp;
    this.patientList = patientList;
    this.isTableLoading = false;
    const listePatients = document.querySelector('#liste-patients');
    if (listePatients) {
      listePatients.scrollIntoView();
    }
  }

  // Tri du tableau de résultats
  public async onSort(event: any): Promise<void> {
    this.filtre.currentPage = 1;
    this.filtre.sortOrder = event.sortOrder;
    this.filtre.sortBy = event.sortBy;
    this.lancerRecherche();
  }

  // Changement de page dans le tableau de résultats
  public async onChangePage(value: any): Promise<void> {
    this.filtre.currentPage = value;
    this.lancerRecherche();
  }

  // Redirection vers la fiche patient
  async openPatient(event: any) {
    this._router.navigateByUrl(`/user/patient/${event.id}`);
  }

  // Stocke la recherche courante dans la session
  async storeSearchSession() {
    sessionStorage.setItem("recherche-multi-critere", JSON.stringify(this.listeCriteresRecherche));
  }

  // Recharge, si disponible, la recherche de la session courante
  async loadSearchSession() {
    if (sessionStorage.getItem("recherche-multi-critere")) {
      this.listeCriteresRecherche = JSON.parse(sessionStorage.getItem("recherche-multi-critere"));
      this.refreshCritere();
    }
  }

  // Ouvre la modale de sauvegarde des recherches
  public saveSearch() {
    if (!this.rechercheSauvegardee) {
      this.rechercheSauvegardee = {
        titre: ""
      };
    }
    this.rechercheSauvegardee.criteres = this.listeCriteresRecherche;

    this.modalService.openModalSaveRecherchesMultiCriteres(this._viewRef, 'Sauvegarder une recherche', this.rechercheSauvegardee, this.refreshStream);
  }

  // Ouvre la modale de chargement des recherches
  public loadSearch() {
    this.modalService.openModalListeRecherchesMultiCriteres(this._viewRef, 'Charger une recherche', this.refreshStream);
  }

  public onSearchValeur(event: any) {
    this.valueListFiltered = this.valueList.filter(
      x => x.label.toLocaleLowerCase().includes(event.toLocaleLowerCase())
    );
  }

  async exportToCsv() {
    if (this.listeCriteresRecherche.length === 0) {
      return;
    }
    this.isTableLoading = true;
    try {
      const response = await this.rechercheSvc.exportRecherche(this.listeCriteresRecherche);
      const csvContent = response.value;
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      this.downloadBlob("recherche-multi-criteres.csv", blob);
    } catch (error) {
      // L'erreur est déjà gérée par le service (snackbar)
    } finally {
      this.isTableLoading = false;
    }
  }

  private downloadBlob(filename: string, blob: Blob) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  async cleanPatientList(patients: any[]): Promise<any[]> {
    const result = [];
    const profilsCabinet = await this._cabinet.findCurrentCabinetDestinataire();
    for (let patient of patients) {
      const medecinResp = profilsCabinet.find(x => x.id === patient.suiviPar);
      result.push({
        nomPrenom: patient.nomPrenom,
        dateNaissance: patient.dateNaissance,
        nomNaissance: patient.nomNaissance,
        nomUsgae: patient.nomUsage,
        suiviPar: medecinResp ? medecinResp.qualite + ' ' + medecinResp.nom.toLocaleUpperCase() + ' ' + this._strUtilsSrv.uppercaseFirstCharString(medecinResp.prenom) : undefined
      });
    }
    return result;
  }

  searchCritere(event: any) {
    this.valueListFiltered = this.valueList.filter(
      x => x.label.toLocaleLowerCase().includes(event.toLocaleLowerCase())
    );
  }
}
